import { debounce } from "./utils";

let lastScrollTop = window.scrollY;

export default function () {
  const header = document.querySelector("main > header");
  const debounced = debounce(function () {
    toggleHeaderScrolled(header);
  }, 100);
  window.addEventListener("scroll", debounced);
  toggleHeaderScrolled(header);

  function updateHeaderHeightVariables(event) {
    if (event.matches) {
      // Desktop
      document.body.style.setProperty(
        "--header-height-desktop",
        `${header.offsetHeight}px`
      );
    } else {
      // Mobile
      document.body.style.setProperty(
        "--header-height-mobile",
        `${header.offsetHeight}px`
      );
    }
  }

  const mediaQuery = matchMedia("(min-width: 1024px)");
  mediaQuery.addEventListener("change", updateHeaderHeightVariables);
  updateHeaderHeightVariables(mediaQuery);

  mobileNavIniit();
}

function toggleHeaderScrolled(header) {
  if (window.scrollY > 0) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }

  // console.log(lastScrollTop);
  var st = window.scrollY;
  if (st > lastScrollTop) {
    header.classList.remove("appear");
  } else {
    header.classList.add("appear");
  }
  lastScrollTop = Math.max(0, st);
}

function mobileNavIniit() {
  const header = document.querySelector("main > header");
  const mobileNav = document.querySelector(".js-nav");
  const mobileNavOpen = document.querySelector(".js-mobileNavOpen");
  const mobileNavClose = document.querySelector(".js-mobileNavClose");
  const mobileNavReturn = document.querySelector(".js-mobileNavReturn");

  const expandableItems = document.querySelectorAll(".js-navItemExpandable");

  mobileNav.setAttribute("aria-hidden", true);

  mobileNavOpen.addEventListener("click", function () {
    mobileNav.classList.add("active");
    mobileNavClose.classList.add("active");
    header.classList.add("menu-active");
    mobileNav.removeAttribute("aria-hidden");
  });

  mobileNavClose.addEventListener("click", function () {
    mobileNav.classList.remove("active");
    mobileNavClose.classList.remove("active");
    header.classList.remove("menu-active");
    mobileNav.setAttribute("aria-hidden", true);
  });

  expandableItems.forEach(function (item) {
    item.setAttribute("aria-hidden", true);
    item.addEventListener("click", function () {
      item.classList.add("active");
      item.removeAttribute("aria-hidden");
      mobileNavReturn.classList.add("active");
    });
  });

  mobileNavReturn.addEventListener("click", function () {
    expandableItems.forEach(function (item) {
      item.classList.remove("active");
      mobileNav.setAttribute("aria-hidden", true);
    });
    mobileNavReturn.classList.remove("active");
  });

  header.addEventListener("mouseenter", function () {
    header.classList.add("hover-active");
  });
  header.addEventListener("mouseleave", function () {
    header.classList.remove("hover-active");
  });
}
